import { render, staticRenderFns } from "./InvoicesManagement.vue?vue&type=template&id=3295c3ce&scoped=true"
import script from "./InvoicesManagement.vue?vue&type=script&lang=js"
export * from "./InvoicesManagement.vue?vue&type=script&lang=js"
import style0 from "./InvoicesManagement.vue?vue&type=style&index=0&id=3295c3ce&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3295c3ce",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/jenkins/data/workspace/KCC_AUDIT_PROD_Frontend/node_modules/vue-loader/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3295c3ce')) {
      api.createRecord('3295c3ce', component.options)
    } else {
      api.reload('3295c3ce', component.options)
    }
    module.hot.accept("./InvoicesManagement.vue?vue&type=template&id=3295c3ce&scoped=true", function () {
      api.rerender('3295c3ce', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/client-view/client-admin/InvoicesManagement.vue"
export default component.exports